import api from "./axios";

export const getAllUsers = () => api.get("/users");
export const updateUserApi = (id, data) => api.put(`/users/${id}`, data);
export const createUserApi = (data) => api.post("/auth/register", data);
export const getAllRolesApi = () => api.get("/roles");

export const assignRolesApi = (data) => api.put("/users/assign/roles", data);
export const resetPasswordApi = (userId, data) =>
  api.put(`/users/reset-password/${userId}`, data);

export const getUsersByCapabilitiesApi = (caps) => {
  const capsParam = Array.isArray(caps) ? caps.join(",") : String(caps || "");
  return api.get(`/users/access`, { params: { caps: capsParam } });
};
